module.exports = __webpack_public_path__ + "static/media/plus.d3895f85.svg";